import { useState, useEffect, Fragment } from 'react';
// import _, { isLength } from 'lodash';
// import axios from 'axios';
import AboutAuth from '../../UI/AboutAuth';
import Backdrop from '../../Backdrop/Backdrop';
import Modal from '../../Modal/Modal';
import FilesUploadAction from '../../FileUploadAction/FilesUploadAction';

import { useStore } from '../../../hook-store/store';

// import { marks } from '../../../utils/marks';
// import './VoiceFileUpload.css';

function AudioSlicerFileUpload(props) {

  const { 
    uploadFile,
    setShowUploadModal,
  } = props;
  // console.log('VoiceFileUpload.jsx', props)
  
  const [store, dispatch] = useStore();
  // console.log('store-App.tsx', store);
  const { isAuth } = store.uiStore;
  
  


  // useEffect(() => {
  //   if (gLoading) {
  //     setIsLoading(true);
  //   } else {
  //     setIsLoading(false);
  //   }
  // },[gLoading]);

  // let displayText = mlSpeechText;

  // if (mlSpeechText.length > 300) {
  //   displayText = mlSpeechText.slice(0, 300) + '....';
  // }

  // console.log(uploadFiles)

 
  let audioSlicerFileUploadBody;

  audioSlicerFileUploadBody = (
    <div>
      <Backdrop 
        zIndex={'95'}
        onCancel={() => { 
          setShowUploadModal(false);
        }}
      />
      <Modal
        onClose={() => {
          setShowUploadModal(false);
        }}
      >
        <div >
          <div className='voiceFileUploadSection'>
            <div className='voiceFileUploadTitle'>
              Upload files to Kura Storage
            </div>
          </div>

          {/* {uploadFile && (
           <div className='voiceFileUploadSection'>
              {uploadFile.name}
            </div>
          )}  */}

          
          {isAuth && (
            <div className='voiceFileUploadSection'>
              <FilesUploadAction 
                uploadFiles={[uploadFile]}
                uploadApp={'audioSlicer'}
              />
            </div>
          )}
          {!isAuth && (
            <div className='voiceFileUploadSection'>
              <AboutAuth />
            </div>
          )}
        </div>
      </Modal>
    </div>
  )


  
  return (
    <Fragment>
      {audioSlicerFileUploadBody}
    </Fragment>
  );
}

export default AudioSlicerFileUpload;
